import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, API_BASE } from "../utils/api";
import "./Adminedit.css";

export default function AdminEditProduct() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [currentImage, setCurrentImage] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const res = await api.get(`/api/products/${id}`);
      setTitle(res.data.title);
      setPrice(res.data.price_aed);
      setCurrentImage(res.data.image_url || "");
    })();
  }, [id]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);

    try {
      const fd = new FormData();
      fd.append("title", title);
      fd.append("price_aed", price);
      if (image) fd.append("image", image);

      await api.put(`/api/products/${id}`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      navigate("/admin/products");
    } catch (error) {
      setErr(error.response?.data?.message || "Failed to update product");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adminFormPage">
      <h2>Edit Product</h2>
      {err && <div className="formError">{err}</div>}

      <form className="adminForm" onSubmit={submit}>
        <label>Title</label>
        <input value={title} onChange={(e) => setTitle(e.target.value)} required />

        <label>Price (AED)</label>
        <input value={price} onChange={(e) => setPrice(e.target.value)} required />

        {currentImage && (
          <div style={{ marginBottom: 10 }}>
            <small>Current Image:</small><br />
            <img
              src={`${API_BASE}${currentImage}`}
              alt="current"
              style={{ width: 120, borderRadius: 12, marginTop: 6 }}
            />
          </div>
        )}

        <label>New Image (optional)</label>
        <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />

        <button disabled={loading}>{loading ? "Updating..." : "Update Product"}</button>
      </form>
    </div>
  );
}